import type { AuditChange } from '../../types/admin';

interface Props {
  change: AuditChange;
}

function formatValue(v: string | null): string {
  if (v === null) return '[empty]';
  if (v.length > 80) return `${v.slice(0, 80)}…`;
  return v;
}

const sourceBadge: Record<string, string> = {
  user: 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300',
  bootstrap: 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300',
  'system:unknown': 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300',
};

function badgeClass(source: string): string {
  if (source.startsWith('sync:'))
    return 'bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300';
  if (source.startsWith('script:'))
    return 'bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300';
  return sourceBadge[source] ?? 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300';
}

export function AuditChangeRow({ change }: Props) {
  const entity = change.entityLabel ?? `${change.entityType}:${change.entityId}`;
  return (
    <div className="grid grid-cols-12 gap-2 px-3 py-2 border-t border-gray-100 dark:border-gray-700 text-sm">
      <div className="col-span-2 text-xs text-gray-500 dark:text-gray-400">
        {new Date(change.changedAt).toLocaleString()}
      </div>
      <div className="col-span-2">
        <span className={`text-xs px-1.5 py-0.5 rounded ${badgeClass(change.changedBySource)}`}>
          {change.changedBySource}
        </span>
      </div>
      <div className="col-span-3 truncate text-gray-900 dark:text-gray-100" title={entity}>
        {entity}
      </div>
      <div className="col-span-1 text-gray-600 dark:text-gray-400">{change.fieldName}</div>
      <div className="col-span-4 text-xs text-gray-700 dark:text-gray-300">
        <span className="line-through text-gray-400 dark:text-gray-500">{formatValue(change.oldValue)}</span>
        <span className="mx-1">→</span>
        <span className="font-medium">{formatValue(change.newValue)}</span>
      </div>
    </div>
  );
}
